<template>
  <div class="earning-framework">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col xl="4">
                  <span class="pull-left" v-if="isRefreshing" style="display:inline-block;padding:0.5em 0.5em 0.5em 0;">
                    <i class="fa fa-spinner"></i>&nbsp;{{ $t('earning_framework.refresh_data_loading') }}
                  </span>
                </b-col>
                <b-col xl="8">
                  <div class="pull-right">
                    <b-input-group v-bind:prepend="$t('earning_framework.date_range')">
                      <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <span :style="{ width: getColumnWidth(item), display: 'inline-block' }">
                        <i class="fa fa-sort-amount-asc text-muted"
                        v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                        <i class="fa fa-sort-amount-desc text-muted"
                        v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                        <span v-if="item.label != null">{{$t('earning_framework.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('earning_framework.'+item.name)}}</span>
                      </span>
                    </th>
                    <th scope="col">{{$t('earning_framework.banner_image')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 2">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                      <span v-if="field.render != null"
                      v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" style="width:420px;">
                      <span style="display:inline-block; padding: 4px;">
                        <span style="display:block;padding-bottom:0.5em;" v-if="item.banner_image != null && item.banner_image != ''">
                          <img
                            :src="item.banner_image"
                            class="img-thumbnail" style="width: fit; height: 100px; object-fit: cover;" />
                        </span>
                        <input class="pull-left"
                          type="file"
                          @change="onBannerFileChanged($event, item.id)"
                          accept=".jpg,.jpeg,.png"
                          capture
                        />
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <!-- <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                  v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row> -->
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style>
  .switch-success > .switch-input:checked ~ .switch-label,
  .btn-success,
  .btn-primary
  {
    background: #0086FF !important;
    border-color: #0086FF !important;
    border-radius: 3px;
  }
  .zoom {
    transition: transform .2s; /* Animation */
    margin: 0 auto;
  }

  .zoom:hover {
    transform: scale(1.5); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  }
</style>
<style scoped>
  .table thead th:nth-child(1){
    width: 100px;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DateRangePicker from 'vue2-daterange-picker'
import DataTable from '../../../components/Partials/DataTable'
import axios from 'axios'
import cSwitch from '../../../components/Switch'
import moment from 'moment-timezone'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'EarningFrameworkList',
  components: {
    SelectDropdown,
    DateRangePicker,
    cSwitch,
    DataTable
  },
  data: function () {
    return {
      isRefreshing: false,
      timezone: 'Asia/Tokyo',
      dateTimeFormat: 'YYYY-MM-DD',
      authUser: this.$auth.user().user_info.user,
      languages: {},
      type: 'like',
      filter: {
        options: [],
        name: '',
        field: null,
        key: null,
        startAt: this.$moment().add(-1, 'months').format('YYYY-MM-DD'),
        endAt: this.$moment().add(1, 'months').format('YYYY-MM-DD'),
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'name',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'promotion_tier',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data.length > 0 ? data.map(item => item.toUpperCase()).join(', ') : ''
            }
          },
          {
            name: 'grant_rate',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data + 'x'
            }
          },
          {
            name: 'start_date',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'end_date',
            filter: false,
            sort: false,
            render: (data, row) => {
              return data
            }
          },
          {
            name: 'expiry_date',
            filter: false,
            sort: false,
            render: (data, row) => {
              return data
            }
          }
        ],
        sort: {
          field: 'start_date',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 99999,
        source: null
      },
      item: {}
    }
  },
  methods: {
    updateDateRange (val) {
      this.date = val
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(1, 'month').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().add(1, 'month').format('YYYY-MM-DD')
      this.refreshData({
        startAt: this.filter.startAt,
        endAt: this.filter.endAt
      })
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in vm.dataTable.fields) {
        if (vm.dataTable.fields[i].name == field
        && (vm.dataTable.fields[i].sort == null || vm.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (vm.dataTable.sort.field != field) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (vm.dataTable.sort.type == 'asc') {
          vm.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      vm.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData (filters) {
      if (cancel != null) {
        cancel()
        this.isRefreshing = false
      }

      this.isRefreshing = true
      //get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_field: this.dataTable.sort.field,
        sort_type: this.dataTable.sort.type
      }
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      //process to send via get method
      let params = '';
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      //remove tail
      params = params.slice(0, -1)
      let from, to;
      if (filters) {
        from = filters.startAt
        to = filters.endAt
      }
      vm.axios.earningFramework.getActivePromotions({ ...params, from: this.filter.startAt, to: this.filter.endAt },
        function(response){
          vm.isRefreshing = false
          vm.dataTable.items = response.data.data.items.map(item => {
            // Format dates
            item.start_date = item.start_date ? moment(item.start_date).tz(vm.timezone).format(vm.dateTimeFormat) : ''
            item.end_date = item.end_date ? moment(item.end_date).tz(vm.timezone).format(vm.dateTimeFormat) : ''
            item.expiry_date = item.expiry_date ? moment(item.expiry_date).tz(vm.timezone).format(vm.dateTimeFormat) : ''
            return item
          })
          vm.dataTable.total = response.data.data._metadata.total || 100
        }, function(error) {
          this.isRefreshing = false
        });
    },
    getColumnWidth(item) {
      if (item.width != null) {
        return item.width
      }
      if (item.name == 'name') {
        return '256px'
      } else if (item.name == 'promotion_tier') {
        return '128px'
      } else if (item.name == 'start_date' || item.name == 'end_date' || item.name == 'expiry_date') {
        return '80px'
      }
      return '128px'
    },
    onBannerFileChanged(event, id) {
      const maxSize = 1 * 1024 * 1024 // 2MB limit
      const file = event.target.files[0]
      if (file) {
        // Accept only image files
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg']
        if (!validTypes.includes(file.type)) {
          vm.$toastr.error(vm.$t('message.invalid_image_file_type'), vm.$t('message.error'), {})
          event.target.value = ''
          return
        }
        if (file.size > maxSize) {
          vm.$toastr.error(vm.$t('earning_framework.file_too_large', { max_size: Math.floor(maxSize / 10**6) }), vm.$t('message.error'), {})
          event.target.value = ''
          return
        }
        if (confirm('Would you like to upload this banner?')) {
          const formData = new FormData()
          formData.append('file', file)

          event.target.disabled = true
          vm.axios.earningFramework.uploadBanner(id, formData, function (response) {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            event.target.value = ''
            event.target.disabled = false
            vm.refreshData()
          }, function (error) {
            vm.$toastr.error(vm.$t('message.update_fail'), vm.$t('message.error'), {})
            event.target.value = ''
            event.target.disabled = false
          })
        } else {
          event.target.value = ''
          event.target.disabled = false
        }
      }
    },
    getSortFilter () {
      for (let i in vm.dataTable.fields) {
        vm.getFilter(i)
        vm.getSort(i)
      }
    },
    getFilter (i) {
      if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
    },
    getSort (i) {
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true
        && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: vm.dataTable.fields[i].name,
          type: 'asc'
        }
      }
    },
    applyFilter () {
      let filter = vm.$session.get('filter', null)
      if (filter != null && vm.$route.query && vm.$route.query.rollback) {
        for (let i in filter.filter) {
          vm.filter[i] = filter.filter[i]
        }
        for (let i in filter.dataTable) {
          vm.dataTable[i] = filter.dataTable[i]
        }
      }
    }
  },
  created: function () {
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()
    vm.getSortFilter()
    vm.$Progress.start()
    vm.applyFilter()
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
  },
  computed : {
    date_locale: function () {
      let format = this.format_date_range_locale()
      if (this.$refs.drange) {
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges : function () {
      return vm.format_date_ranges()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/earning-framework/List.vue